<template>
    <base-button class="text-sm font-black tracking-widest">
        <!-- Library build does not like dynamic URLs -->
        <img v-if="iconName === 'help'"
            src="../assets/images/icons/help.svg"
            :alt="iconName"
            class="mr-2"
        >

        <img v-if="iconName === 'undo'"
            src="../assets/images/icons/undo.svg"
            :alt="iconName"
            class="mr-2"
        >

        <img v-if="iconName === 'share'"
            src="../assets/images/icons/share.svg"
            :alt="iconName"
            class="mr-2"
        >

        <img v-if="iconName === 'info'"
            src="../assets/images/icons/info.svg"
            :alt="iconName"
            class="mr-2"
        >

        <span :class="{ 'cz-hidden sm:inline': hideText }">
            {{ buttonText }}
        </span>
    </base-button>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            iconName: {
                type: String,
                required: true,
            },
            buttonText: {
                type: String,
                default: '',
            },
            hideText: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
